var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedReminderOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59203 8.36984C2.8305 6.51918 3.71341 4.40158 5.56407 3.64005L6.39488 3.29818C8.24554 2.53665 10.3631 3.41957 11.1247 5.27023V5.27023L11.1336 5.2918C11.6461 6.53734 12.4376 7.64866 13.4471 8.54021V8.54021C13.9357 8.97169 13.8022 9.76604 13.1994 10.0141L5.45692 13.2C4.85412 13.4481 4.20021 12.9778 4.24362 12.3274V12.3274C4.33331 10.9835 4.11343 9.63695 3.6009 8.39141L3.59203 8.36984V8.36984Z",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39844 12.7998L10.1144 11.3193L10.2624 11.6909C10.6712 12.717 10.1708 13.8802 9.14472 14.2891V14.2891C8.11859 14.6979 6.95533 14.1975 6.54649 13.1714L6.39844 12.7998Z",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19922 3.2002L6.78879 2.07256C6.56212 1.44979 5.87351 1.12869 5.25074 1.35536V1.35536C4.62797 1.58203 4.30686 2.27064 4.53353 2.89341L4.94396 4.02104",
    stroke: "#20242E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2008 8.1999C13.0785 8.1999 14.6008 6.67767 14.6008 4.7999C14.6008 2.92213 13.0785 1.3999 11.2008 1.3999C9.32301 1.3999 7.80078 2.92213 7.80078 4.7999C7.80078 6.67767 9.32301 8.1999 11.2008 8.1999Z",
    fill: "#00B16A",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedReminderOn);
export default __webpack_public_path__ + "static/media/ic-shared-reminder-on.61f2b7d8c0de7ca003703f3ac26d0444.svg";
export { ForwardRef as ReactComponent };